// packages/core/src/types/index.ts

/**
 * Core type definitions for Sharpee
 * These are generic types that can be used by any narrative system
 */

export * from './entity.js';
export * from './relationship.js';
export * from './attribute.js';
export * from './result.js';
export * from './save-data.js';
